import "./dccf42bc042f4dbb3a3c2a822e0bd9d4.css";
export default {"container":"_rRZ4l"};